import { UpdateLoginSateActions } from '@westwing/appshell_types/customEventTypes';
import { OverlayId } from 'Types/types';
import { dispatchCustomEvent } from 'AppShell/communication';

interface UseCustomEventReturnType {
    showDoiOverlay: () => void;
    hideOverlay: (overlayId: OverlayId) => void;
    updateUserData: (action: UpdateLoginSateActions) => void;
    showNotification: (message: string) => void;
}

export const useCustomEvent = (): UseCustomEventReturnType => {
    // TODO Handle doi on MF side.
    const showDoiOverlay = () => {
        dispatchCustomEvent('UPDATE_OVERLAYS', {
            detail: {
                action: 'SHOW',
                id: OverlayId.DOUBLE_OPT_IN_OVERLAY,
            },
        });
    };

    const hideOverlay = (overlayId: OverlayId) => {
        dispatchCustomEvent('UPDATE_OVERLAYS', {
            detail: {
                action: 'HIDE',
                id: overlayId,
            },
        });
    };

    const updateUserData = (action: UpdateLoginSateActions) => {
        dispatchCustomEvent('UPDATE_LOGIN_STATE', { detail: { action } });
    };

    const showNotification = (message: string) => {
        dispatchCustomEvent('NOTIFICATION', {
            detail: {
                displayType: 'default',
                action: 'SHOW',
                message,
            },
        });
    };

    return {
        showDoiOverlay,
        hideOverlay,
        updateUserData,
        showNotification,
    };
};
